import { BasePlugin } from '../base'
import mdcTab from './mdc-tab.vue'
import mdcTabBar from './mdc-tab-bar.vue'

export { mdcTab, mdcTabBar }

export default BasePlugin({
  mdcTab,
  mdcTabBar
})
